<mat-tab-group mat-stretch-tabs="false" id="matTbGrp">
  <mat-tab [label]="'profile.user_profile' | translate" id="matTbProfile">
    <ng-container *ngIf="response">
      <app-user-profile
        [response]="response"
        id="comUserProfile"
        (updatedUser)="updateUser($event)"
      ></app-user-profile>
    </ng-container>
  </mat-tab>
  <mat-tab [label]="'profile.reset_password' | translate" id="matTbResetPassword">
    <app-reset-password id="comResetPassword"></app-reset-password>
  </mat-tab>
</mat-tab-group>
